<template>
  <div class="rank">
    <carousel :images="imgs"
              arrow="never"
              style="z-index: -1;">
    </carousel>
    <!-- 说明 -->
    <div class="shuoming">
      <div class="fixed_width"
           style="padding: 0px 0.2rem;">
        <div class="header_title"
             v-bind:class="{ en: lang === 'en' }">
          <img src="@/assets/images/rank_logo.png">
          <div v-if="!mobileDevice"
               style="margin-top: 0.4rem;">
            {{$t('rank.headerTitle1')}}
          </div>
          <div v-if="!mobileDevice">
            {{$t('rank.headerTitle2')}}
          </div>
          <div v-if="mobileDevice"
               style="margin-top: 0.4rem;">
            {{$t('rank.headerTitle')}}
          </div>
        </div>
        <div class="subTitle">{{$t('rank.subTitle')}}</div>
      </div>
    </div>
    <!-- 内容 -->
    <el-row class="fixed_width main">
      <el-col :sm="17"
              :xs="24">
        <div class="paragraph title1">{{$t('rank.content_title1')}}</div>

        <div class="paragraph"
             v-if="lang === 'zh'">
          近日，罗兰贝格联合优与科技对<span class="jiacu">2019年中国新能源汽车市场中的纯电动车型保值率进行了深入研究，并按不同的车身形式进行了保值率分类排名</span>，旨在帮助主机厂更好、更真实地了解自身品牌量化保值水平，发现差距，识别行业领先产品和优秀实践，通过产品、商业模式等综合手段，衡量和监控品牌和产品价值提升水平，以最终助力提升品牌与产品价值，支持整个新能源汽车行业的健康和可持续发展。
        </div>
        <div class="paragraph"
             v-if="lang === 'en'">
          Recently, Roland Berger and Autobole have conducted in-depth research on the Residual Value Indicator of BEV in China's NEV market in 2019, and ranked the Residual Value Indicator according to different body forms. This aims to help OEMs better and more truly understand their own brand quantitative residual value level, find the gaps, and identify industry-leading products and excellent practices. Through products, business models and other comprehensive means, to measure and monitor the level of brand and product value improvement, in order to ultimately promote the brand and product value, to support the healthy and sustainable development of the whole NEV industry.
        </div>
        <div class="paragraph title">{{$t('rank.content_title2')}}</div>
        <div class="paragraph"
             v-if="lang === 'zh'">
          通过<span class="jiacu">建立基于新能源车辆残值影响因子的算法模型对新能源二手车残值进行评估与预测，并结合市场调研对输出的结果进行修正与校准，优与科技与罗兰贝格基于量化分析共同为新能源车企实施车辆全生命周期残值管理提供数据支持</span>。本次排名仅针对纯电动汽车，插电式混动及燃料电池汽车等不在本次讨论范围内。同时，对于社会突发事件（如本次新冠肺炎疫情）等对车辆保值率的影响暂未涉及与考虑。
        </div>
        <div class="paragraph"
             v-if="lang === 'en'">
          By establishing an algorithm model based on NEV residual value influence factor to evaluate and predict the residual value of used NEV, and combining with market research to modify and calibrate the output results. Based on the quantitative analysis, Autobole and Roland Berger jointly provide data support for the implementation of vehicle lifecycle residual value management by NEV OEMs. This ranking is only for pure electric vehicles, so plug-in hybrid and fuel cell vehicles are not included in this discussion. Meanwhile, the impact of social emergencies (such as this outbreak of COVID 19) on vehicle maintenance rate has not been discussed and considered.
        </div>
        <div class="paragraph title">{{$t('rank.content_title3')}}</div>
        <template v-if="lang === 'zh'">
          <div class="paragraph point">
            <span class="jiacu">目前新能源汽车保值率整体偏低，主要归因于几大因素</span>
            ，即
            <span class="jiacu">电池技术的快速进步</span>
            ，使得车辆整体性能较前期产品有较大的提升；
            <span class="jiacu">缺乏统一的新能源汽车检测评估标准，特别是对于动力电池的检测评估</span>
            ，阻碍了二手车的流通；
            <span class="jiacu">新能源二手车交易量有限，暂未形成稳定的供需关系</span>
            ，导致成交价与车辆实际价值之间形成较大的偏离。
            <span class="jiacu">通过对2019年中国纯电动车型保值率进行梳理，我们发现保值率在50%及以上的车型在整体新能源汽车市场上处于相对领先的水平</span>
            ，其中部分主机厂在新车营销及二手车再营销层面早早布局，通过发布认证二手车项目、保值回购服务以及提供免费加电、免费保养等增值服务，以三位一体的整体战略逐步消除消费者对新能源汽车的电池与残值忧虑，不断提升消费者的用车体验，为其较高的保值率提供了有利的保障。
          </div>
          <div class="paragraph point">
            <span class="jiacu">纯电动SUV保值率排名较为明显地分为两个阶梯，豪华品牌纯电动SUV处于第一阶梯，自主品牌主流车型居于第二阶梯</span>。第一与第二阶梯车型都具有较高的产品力，但在残值管理及再营销策略的运用上存在明显区别，最终导致其保值率出现较大差异。
          </div>
          <div class="paragraph point">
            <span class="jiacu">纯电动轿车保值率排名中，普遍被认为是一线合资品牌的车型反而处于保值率的中间水平</span>，主要原因在于其推出的新能源产品大部分处于过渡阶段，新能源战略产品尚未推出，残值管理和再营销策略尚未全面推向市场。
          </div>
        </template>
        <template v-if="lang === 'en'">
          <div class="paragraph point">
            At present, the overall low residual value indicator of NEVs is mainly due to several factors, that is, the rapid progress of battery technology, which makes the overall performance of vehicles have a greater improvement than the previous products; The lack of unified inspection and evaluation standards for NEVs, especially for power batteries, hinders the circulation of used cars. The trading volume of used NEVs is limited, as well as the stable supply and demand relationship has not yet been formed, resulting in a large deviation between the transaction price and the actual value of vehicles. By combing the residual value indicator of China's BEV in 2019, we find that the models with 50% residual value indicator or more are in a relatively leading position in the overall NEV market, and some of the OEMs have made early layout in the new car marketing and used car remarketing. By issuing CPO program, the trade-in warranty value service and providing value-added services such as free charging and free maintenance, with the trinity of the overall strategy to gradually eliminate consumers on the NEV battery and residual value concerns, and constantly improves consumers' car experience, which provides a favourable guarantee for its residual value indicator to be in a high position.
          </div>
          <div class="paragraph point">
            The residual value indicator ranking of BEV SUVs is obviously divided into two steps. Luxury brand BEV SUVs are in the first step, and the mainstream models of local brands are in the second step. The models in first and second step both have higher product capabilities, but there are obvious differences in the use of residual value management and remarketing strategies, which ultimately lead to a large difference in the residual value indicator.
          </div>
          <div class="paragraph point">
            On the contrary, the models generally considered as first-tier joint venture brands are in the middle of maintenance rate in the residual value indicator ranking of BEV sedans. The main reason is that most of released NEV products are in the transition stage, the NEV strategic products have not been launched, as well as residual value management and remarketing strategies have not been fully introduced to the market
          </div>
        </template>
        <div class="paragraph title1">{{$t('rank.content_title4')}}</div>
        <div class="imgTitle">{{$t('rank.imageTitle1')}}</div>
        <div class="imageBox">
          <img v-if="lang === 'zh'"
               src="@/assets/images/rank_top1.png">
          <img v-if="lang === 'en'"
               src="@/assets/images/rank_top1_en.png">
        </div>
        <div class="detail">{{$t('rank.detail')}}</div>
        <div class="imageBox">
          <img v-if="lang === 'zh'"
               src="@/assets/images/rank_top2.png">
          <img v-if="lang === 'en'"
               src="@/assets/images/rank_top2_en.png">
        </div>
        <div class="imgTitle">{{$t('rank.imageTitle2')}}</div>
        <div class="imageBox">
          <img v-if="lang === 'zh'"
               src="@/assets/images/rank_top3.png">
          <img v-if="lang === 'en'"
               src="@/assets/images/rank_top3_en.png">
        </div>
        <div class="detail">{{$t('rank.detail')}}</div>
        <div class="imageBox">
          <img v-if="lang === 'zh'"
               src="@/assets/images/rank_top4.png">
          <img v-if="lang === 'en'"
               src="@/assets/images/rank_top4_en.png">
        </div>
        <!-- 尾言 -->
        <div class="paragraph title1">{{$t('rank.content_title5')}}</div>
        <div class="paragraph"
             v-if="lang === 'zh'">
          <span class="jiacu">随着新能源产品和技术的飞速发展与迭代，新能源车面临严峻的保值问题，多元化的生命周期服务与残值管理方案逐渐成为各主机厂重点关注和探索的领域，新能源汽车普及的时代离我们越来越近，解决新能源车所带来的多方面挑战已然成为当下的任务。</span>
          <span class="jiacu">2020年，尽管我们面临的问题前所未有地复杂而严峻，但是我们相信，</span>
          <span class="jiacu">机遇同时蕴含在挑战之中，未来在新能源汽车赛道上胜出的赢家，一定属于那些着眼于解决本质问题，长远布局，果敢行动的汽车人。</span>
        </div>
        <div class="paragraph"
             v-if="lang === 'en'">
          With the rapid development of new energy products and technologies, NEVs are facing a serious problem of residual value. Diversified life cycle services and residual value management programs have gradually become the focus and exploration field of OEMs. The era of the popularization of NEVs is getting closer to us. It has become the current task to solve various challenges brought by NEVs. In 2020, while the problems we face are more complex and severe than ever before, we believe that the opportunities are contained in the challenges. The future winners in the NEV "racing circuit" must belong to those who focus on solving the essential problems, long-term layout and bold action.
        </div>
      </el-col>
      <el-col :sm="7"
              :xs="0">
        <div class="share">{{$t('rank.share')}}<i class="el-icon-link"
             v-on:click="copyLink"></i></div>
        <input id="demoInput"
               value="http://www.autobole.com/#/rank">
      </el-col>
    </el-row>
    <!-- end -->
  </div>
</template>

<script>
import Carousel from '@/components/carousel'
import headerImg from '@/assets/images/rank_header.png'
import headerImgMobile from '@/assets/images/rank_header_mobile.png'

export default {
  components: {
    Carousel
  },
  computed: {
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice
      }
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'rank_detail') {
        this.showDetal()
      } else {
        this.hideDetail()
      }
    }
  },
  data() {
    return {
      imgs: [headerImg, headerImgMobile],
      visibleDetail: false
    }
  },
  methods: {
    showDetal() {
      this.visibleDetail = true
    },
    hideDetail(path) {
      this.$router.push({ path })
      this.visibleDetail = false
    },
    copyLink() {
      const input = document.querySelector('#demoInput')
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success('复制成功')
      }
    },
    download() {
      window.open('http://autobole-rv-http.autobole.net/RB%C2%A0FOC%C2%A0%E6%96%B0%E8%83%BD%E6%BA%90%E6%B1%BD%E8%BD%A6%E5%85%A8%E7%94%9F%E5%91%BD%E5%91%A8%E6%9C%9F%E4%BA%A7%E4%B8%9A%E5%8F%91%E5%B1%95%E6%8C%91%E6%88%98%E4%B8%8E%E5%B1%95%E6%9C%9B%EF%BC%8C%E6%9A%A82020%E9%A9%BE%E5%80%BC%E6%A6%9C%E5%8F%91%E5%B8%83%C2%A0200319.pdf')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/header_box.scss";
@import "../../style/content_title.scss";
@import "../../style/fixed_width.scss";
.rank {
  .shuoming {
    margin: 0 auto;
    padding: 0.3rem 0.6rem;
    text-align: left;
    margin-top: -3.53rem;
    height: 4.32rem;
    opacity: 0.94;
    padding-bottom: 0px;
    background: linear-gradient(
      135deg,
      rgba(61, 178, 222, 1) 0%,
      rgba(71, 214, 184, 1) 100%
    );
    img {
      width: 3rem;
    }
    .header_title {
      height: 3.31rem;
      font-size: 0.35rem;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 0.76rem;
      letter-spacing: 0.02rem;
      // &.en {
      //   line-height: 0.58rem;
      // }
    }
    .subTitle {
      font-size: 0.18rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 0.6rem;
      letter-spacing: 0.01rem;
    }
  }

  .fixed_width {
    text-align: left;
  }

  .main {
    .subTitle {
      font-size: 0.2rem;
      font-weight: 300;
      color: rgba(27, 27, 27, 1);
      line-height: 0.3rem;
    }

    .fixed_width {
      text-align: left;
    }
    // 段落
    .paragraph {
      // font-size: 0.14rem;
      font-size: 0.16rem;
      font-weight: 400;
      color: #494949;
      word-break: break-all;
      // line-height: 0.23rem;
      line-height: 0.28rem;
      padding: 0.07rem 0.1rem;
      letter-spacing: 0.01rem;

      &.title1 {
        // font-size: 0.18rem;
        font-size: 0.2rem;
        color: rgba(0, 0, 0, 1);
        line-height: 0.34rem;
        font-weight: bold;
        margin-top: 0.1rem;
      }

      &.title {
        color: #069dcc;
        font-weight: bold;
        // font-size: 0.18rem;
        font-size: 0.2rem;
        margin-top: 0.1rem;
      }

      .jiacu {
        font-weight: bold;
        color: #1b1b1b;
      }

      &.point {
        padding-left: 0.5rem;
        position: relative;

        &:before {
          content: "";
          position: absolute;
          left: 0.24rem;
          top: 0.16rem;
          width: 0.08rem;
          height: 0.08rem;
          background: rgba(49, 155, 229, 1);
          border-radius: 50%;
        }
      }
    }

    .imgTitle {
      // font-size: 0.14rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: rgba(6, 157, 204, 1);
      line-height: 0.21rem;
      margin: 0.3rem 0.1rem;
    }

    .imageBox {
      width: 100%;
      text-align: center;
      // margin-top: 0.5rem;
      // margin-bottom: 0.3rem;
      img {
        max-width: 80%;
        width: 6.61rem;
      }
    }

    .detail {
      // font-size: 0.14rem;
      font-size: 0.16rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 0.28rem;
      letter-spacing: 0.01rem;
      padding: 0.2rem 0;
      text-align: center;
      span {
        color: rgba(49, 155, 229, 1);
        cursor: pointer;
      }
    }

    .share {
      margin-left: 30%;
      margin-top: 0.25rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: rgba(162, 162, 162, 1);
      line-height: 0.27rem;
      letter-spacing: 0.01rem;
      i {
        cursor: pointer;
      }
    }
    #demoInput {
      opacity: 0;
    }
  }

  @media only screen and (max-width: 750px) {
    .shuoming {
      padding: 0.2rem 0.4rem;
      .subTitle {
        line-height: 0.8rem;
      }
    }

    .fixed_width {
      padding: 0 0.15rem;
    }

    .header_title {
      line-height: 0.7rem !important;
      &.en {
        // line-height: 0.58rem;
        font-size: 0.33rem;
        line-height: 0.45rem !important;
      }
    }
  }
}
</style>
